/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ n: NonNullable<unknown> }} Inbox_Na_Detail_PhaseInputs */

const en_inbox_na_detail_phase = /** @type {(inputs: Inbox_Na_Detail_PhaseInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Stage ${i?.n} is waiting for your approval`)
};

const id_inbox_na_detail_phase = /** @type {(inputs: Inbox_Na_Detail_PhaseInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tahap ${i?.n} menunggu persetujuanmu`)
};

/**
* | output |
* | --- |
* | "Stage {n} is waiting for your approval" |
*
* @param {Inbox_Na_Detail_PhaseInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const inbox_na_detail_phase = /** @type {((inputs: Inbox_Na_Detail_PhaseInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbox_Na_Detail_PhaseInputs, { locale?: "en" | "id" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_inbox_na_detail_phase(inputs)
	return en_inbox_na_detail_phase(inputs)
});